export default "__VITE_ASSET__0sfsjl0m__"